import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-dc-gradient flex items-center justify-center p-4">
      <form onSubmit={submit} className="glass-strong rounded-3xl w-full max-w-md p-6 sm:p-8">
        <Link to="/" className="font-display text-xl tracking-widest text-white">DILCONNECT</Link>
        <h1 className="font-display mt-4 text-2xl font-extrabold">Welcome back</h1>
        <div className="mt-6 space-y-3">
          <input data-testid="login-email" type="email" required placeholder="Email" className="dc-input" value={email} onChange={(e)=>setEmail(e.target.value)} />
          <input data-testid="login-password" type="password" required placeholder="Password" className="dc-input" value={password} onChange={(e)=>setPassword(e.target.value)} />
        </div>
        <button data-testid="login-submit" disabled={busy} className="btn-cta mt-6 w-full py-3 rounded-2xl">{busy ? "Signing in…" : "Sign in"}</button>
        <div className="mt-4 text-xs text-purple-200/70 text-center">
          New here? <Link to="/register" className="text-white font-semibold">Create an account</Link>
        </div>
        <style>{`
          .dc-input{width:100%;background:rgba(10,4,20,0.6);border:1px solid rgba(168,85,247,0.3);border-radius:12px;padding:10px 12px;font-size:14px;outline:none;color:#fff}
          .dc-input:focus{border-color:#c084fc;box-shadow:0 0 0 3px rgba(192,132,252,0.2)}
        `}</style>
      </form>
    </div>
  );
}
